/**
 * @author      [leiling.cp]
 * @version     [1.0.0]
 * @dete        [2015/3/20]
 * @description [主动营销消息框]
 */

var $ = require("@alife/alpha-jquery/jquery"),
    LocalStorageDB = require("./localstorage-db"),
    Util = require("./util"),
    Widget = require("@alife/alpha-widget/widget"),
    //AtmPlugin = require("@alife/alpha-alitalk/atm-plugin.js"),
    Domdot = require("@alife/alpha-domdot/domdot");

var MessageBox = Widget.extend({
    attrs: {
        page: 'webDetail',
        uid: '',
        marketingId: '',
        contactId: '',
        contactName: '',
        contactImg: '',
        productId: '',
        destProductId: '',
        message: '',
        marketType: '',
        country: '',
        originTime: '',
        boxType: 0,
        isWeblite: false
    },
    events: {
        'click': 'startChat'
    },
    parseElement: function() {
        var self = this;
        var contactImg = self.get('contactImg');

        self.element = $('<div id="initiative-sugguestion-a" class="initiative-sugguestion-wrap"><div class="initiative-sugguestion initiative-sugguestion-a"><div class="sugguestion-arrow"></div><div class="sugguestion-close"></div><div class="sugguestion-content-wrap util-clearfix"><div class="sugguestion-content"><div class="sugguestion-msg">You have <span>1</span> message !</div><div class="sugguestion-btn"></div></div><div class="sugguestion-img">' + (contactImg ? '<img src="' + contactImg + '">' : '') + '</div></div></div></div>');

        // 针对二期版本做ab版本比较
        // if (Util.hashCode(self.get('uid')) % 2 == 1) {
        //     self.set('boxType', 1);
        //     self.element = $('<div id="initiative-sugguestion-b" class="initiative-sugguestion-wrap"><div class="initiative-sugguestion initiative-sugguestion-b"><div class="sugguestion-arrow"></div><div class="sugguestion-close"></div><div class="sugguestion-content-wrap util-clearfix"><div class="sugguestion-img"><img src="' + self.get('contactImg') + '"/></div><div class="sugguestion-content"><div class="sugguestion-user">Supplier recommendation:<br/> ' + self.get('contactName') + ' has sent you <span>1</span> message!</div><div class="sugguestion-btn"></div></div></div></div></div>');
        // }
    },
    setup: function() {
        var self = this,
            marketType = self.get('marketType');

        switch (marketType) {
            case 'MK_SYSTEM':
                marketType = 1;
                break;
            case 'MK_AUTO':
                marketType = 2;
                break;
            case 'MKPLATFORM':
                marketType = 2;
                break;
            default:
                marketType = 1;
                break;
        }

        self.set('marketType', marketType);
        self.render();
    },
    render: function() {
        // 调用父类，插入节点
        MessageBox.superclass.render.call(this);

        var self = this,
            marketingId = self.get('marketingId'),
            uid = self.get('uid');

        // 二期曝光打点
        if (self.get('marketType') == '2') {
            Domdot.dotstat(20476, {
                ext: 'uid=' + uid + '|bid=MarketingAnalysis|marketingId=' + marketingId
            });

            // 打点到营销平台
            try {
                new Image().src = '//atmgateway-client.alibaba.com/atmgateway/http/marketingFeedback.do?marketingId=' + marketingId + '&eventType=show&from=webatm&loginId=' + uid;
            } catch (e) {}
        } else {
            if (self.get('page') == 'productDetail') {
                //原B版本打点，现旺铺布点打点
                Domdot.dotstat(14070, {
                    ext: 'uid=' + uid + '|bid=MarketingAnalysis'
                });
            } else {
                Domdot.dotstat(14069, {
                    ext: 'uid=' + uid + '|bid=MarketingAnalysis'
                });
            }

            // 打点到营销平台
            try {
                new Image().src = '//atmgateway-client.alibaba.com/atmgateway/http/marketingFeedback.do?eventId=' + marketingId + '&from=webatm&eventType=show&loginId=' + uid + '&country=' + self.get('country') + '&originTime=' + self.get('originTime') + '&contactId=' + self.get('contactId');
            } catch (e) {}
        }

        // 针对二期版本做ab版本比较B版本曝光打点
        // if (self.get('boxType') == 1) {
        //     Domdot.dotstat(22569, {
        //         ext: 'uid=' + self.get('uid') + '|bid=MarketingAnalysis'
        //     });
        // }
        //

        $(self.element).animate({
            bottom: 0
        }, 1500, function() {
            var timmer = setTimeout(function() {
                $(self.element).hide();
                self.destroy();
            }, 30000);
        });

        return this;
    },
    startChat: function(event) {
        var self = this,
            node = event.currentTarget,
            target = event.target || event.srcElemnt,
            uid = self.get('uid'),
            marketingId = self.get('marketingId');

        event.stopPropagation();
        event.preventDefault();

        $(node).hide();
        if (target.className == 'sugguestion-close') {
            if (self.get('marketType') == '2') {
                Domdot.dotstat(20478);
            } else {
                Domdot.dotstat(17575);
            }
            // 针对二期版本做ab版本比较B版本关闭打点
            // if (self.get('boxType') == 1) {
            //     Domdot.dotstat(22570);
            // }
            return false;
        }

        // 针对二期版本做ab版本比较B版本点击打点
        // if (self.get('boxType') == 1) {
        //     Domdot.dotstat(22571);
        // }

        // 主动营销二期点击打点
        if (self.get('marketType') == '2') {
            Domdot.dotstat(20477);

            // 打点到营销平台
            try {
                new Image().src = '//atmgateway-client.alibaba.com/atmgateway/http/marketingFeedback.do?marketingId=' + marketingId + '&eventType=click&from=webatm&loginId=' + uid;
            } catch (error) {}
        } else {
            //原B版本打点，现旺铺布点打点
            if (self.get('page') == 'productDetail') {
                Domdot.dotstat(2932); //在旺铺公司简介模块（首页+detail+CpIntro++CPVideo+Contacts），记录ATM的点击（注意，新点是同一个点，无法拆分）
                Domdot.dotstat(14072);
            } else {
                Domdot.dotstat(3302, {
                    ext: 'initiative-sugguestion'
                }); //在独立detail页的Product Detail模块中，点击ATM询盘
                Domdot.dotstat(14071);
            }

            // 打点到营销平台
            try {
                new Image().src = '//atmgateway-client.alibaba.com/atmgateway/http/marketingFeedback.do?eventId=' + marketingId + '&from=webatm&eventType=click&loginId=' + uid + '&country=' + self.get('country') + '&originTime=' + self.get('originTime') + '&contactId=' + self.get('contactId');
            } catch (e) {}
        }

        var contactId = self.get('contactId'), // 加密的id
            productId = self.get('productId'),
            destProductId = self.get('destProductId'),
            marketType = self.get('marketType'),
            message = self.get('message'),
            country = self.get('country'),
            originTime = self.get('originTime'),
            url = '//wwatmserver.alibaba.com/GetDecEnemberId.do?callback=?&enemberId=' + encodeURIComponent(contactId);

        // 已经加载了插件,进行打点统计(原ie内核打点，用作插件打点)
        // if (AtmPlugin.isReady()) {
        //     Domdot.dotstat(20070);
        // }

        // 初始化db
        var db = new LocalStorageDB('Marketing', localStorage);
        if (!db.tableExists('MarketingTable')) {
            db.createTable('MarketingTable', ['contactId', 'marketingId', 'type', 'message', 'productId', 'country', 'originTime']);
        }

        $.getJSON(url, function(data) {
            if (data.success) {
                var row = {
                    contactId: data.result,
                    marketingId: marketingId,
                    type: marketType,
                    message: message,
                    productId: productId,
                    country: country,
                    originTime: originTime
                };
                // 这里是解密的ID
                var contactId = data.result;

                // FIXME: 使用localStoreDB存储数据, 不能跨子域, 此处作为旧版WebATM兼容
                // 在后期, 当WebATM应用上线之后, 可考虑将此处localStoreDB相关代码删除掉
                db.insertOrUpdate('MarketingTable', {
                    contactId: contactId
                }, row);
                db.commit();

                // 针对新版WebATM应用, 需要使用store-proxy来进行跨域数据存储
                Util.saveMarketingData(contactId, row);

                if (marketType === 2) {
                    productId = destProductId;
                }

                if (self.get('isWeblite')) {
                    self.get('messageInstance').trigger('MARKET_CHAT', {
                        contactId: self.get('contactId'),
                        marketingId: marketingId,
                        type: marketType,
                        message: message,
                        productId: productId,
                        country: country,
                        originTime: originTime
                    });
                } else {
                    window.WebATM.Main.chatTo(contactId, {
                        from: '1',
                        pid: productId
                    });
                }
            }
        }, 'json');

        return false;
    }
});

module.exports = MessageBox;
